import { AccountObject, IAccountObjectArgs } from "../account-object/account-object.model";

export interface IDefaultTaskArgs extends IAccountObjectArgs {
    taskType: string;
    title: string;
    transitions: Array<string>;
}

const defaults = () => ({
    taskType: undefined,
    title: undefined,
    transitions: []
});

export class DefaultTask extends AccountObject {
    taskType: string;
    title: string;
    transitions: Array<string>;

    constructor(args: IDefaultTaskArgs = {} as any) {
        super({...defaults(), ...args});
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/default-task/default-task.model.ts